<template>
  <div class="main-app-login">
    <div class="container">
      <div class="img-area">
        <img src="../assets/login-3.png" class="img" alt />
      </div>
      <div class="form-area">
        <div class="form">
          <div class="sec-title">
            <span class="h2">重置密码</span>
          </div>
          <div class="input-item">
            <input
              class="input"
              type="text"
              autofocus
              placeholder="请输入您的手机号"
              @keyup.enter="selectRole"
              @input="phoneWarn = ''"
              v-model="form.phone"
            />
            <div class="input-item-tip" v-if="phoneWarn">
              <img slot="prefix" src="../assets/cha.png" class="error" />
              <span>
                {{ phoneWarn }}
              </span>
            </div>
          </div>
          <div class="input-item">
            <input
              class="input"
              type="text"
              autofocus
              @input="codeWarn = ''"
              @keyup.enter="selectRole"
              placeholder="请输入短信验证码"
              v-model="form.code"
            />
            <div
              class="button-min-inner button-min"
              @click="getCode"
              v-if="!getting"
            >
              获取验证码
            </div>
            <div class="button-min-inner button-min" v-if="getting">
              重新获取 {{ time }}s
            </div>
            <div class="input-item-tip" v-if="codeWarn">
              <img slot="prefix" src="../assets/cha.png" class="error" />
              <span>
                {{ codeWarn }}
              </span>
            </div>
          </div>
          <div class="input-item">
            <input
              class="input"
              type="password"
              autofocus
              @input="passwordWarn = ''"
              @keyup.enter="selectRole"
              placeholder="请设置新密码（6-16位数字和字母）"
              v-model="form.password"
            />
            <div class="input-item-tip" v-if="passwordWarn">
              <img slot="prefix" src="../assets/cha.png" class="error" />
              <span>
                {{ passwordWarn }}
              </span>
            </div>
          </div>
          <button
            class="input button-primary"
            type="primary"
            @click="selectRole"
            @keyup.enter="selectRole"
          >
            重置密码
          </button>
        </div>
        <p class="login-register">
          <span @click="login" class="button-min" style="margin-right: 29px"
            >返回登录</span
          >
          <span @click="register" class="button-min">立即注册</span>
        </p>
        <div class="copyright">
          copyright© 2018-{{
            new Date().getFullYear()
          }}.布谷云软件技术(南京)有限公司<span style="margin-left: 10px"></span
          >联系电话：400-166-9695
        </div>
      </div>
    </div>
    <dialog-select ref="dialogSelect"></dialog-select>
  </div>
</template>

<script>
import md5 from "js-md5";
import dialogSelect from "../components/select.vue";
export default {
  data() {
    return {
      form: {
        phone: "",
        password: "",
        code: "",
      },
      phoneWarn: "",
      codeWarn: "",
      passwordWarn: "",
      getting: false,
      time: 60,
      loading: false,
      bubuid: "",
    };
  },
  created() {},
  mounted() {},
  components: {
    dialogSelect,
  },
  methods: {
    validation() {
      this.phoneWarn = "";
      this.codeWarn = "";
      this.passwordWarn = "";
      if (!this.form.phone) {
        this.phoneWarn = "手机号不能为空";
        return false;
      }
      if (!this.form.code) {
        this.codeWarn = "验证码不能为空";
        return false;
      }
      if (!this.form.password) {
        this.passwordWarn = "密码不能为空";
        return false;
      }
      return true;
    },
    getMd5Key(phone) {
      let time = new Date();
      let y = time.getFullYear();
      let m = time.getMonth() + 1;
      let d = time.getDate();
      let day = [y, m >= 10 ? m : "0" + m, d >= 10 ? d : "0" + d];
      let rdmKey =
        (parseInt((Math.random() + 1) * Math.pow(10, 8)) + "").substr(1, 8) +
        day.join("");
      return {
        RDM_KEY: rdmKey,
        SER_KEY: md5(phone + rdmKey + "data_808088"),
      };
    },
    getCode() {
      if (!this.getting) {
        if (this.form.phone.length !== 11) {
          this.phoneWarn = "请填写正确的手机号";
        } else {
          this.getting = true;
          const dis = function (that) {
            setTimeout(() => {
              that.time--;
              if (that.time === 0) {
                that.getting = false;
                that.time = 59;
              } else {
                dis(that);
              }
            }, 1000);
          };
          dis(this);
          this.$api.getCode({
            params: Object.assign({}, this.getMd5Key(this.form.phone), {
              APP_TOKEN: "9C4F2C2F67E34BB29BF296DBDBF26922",
              PHONE: this.form.phone,
              APP_SOURCE: 2,
            }),
            success: (res) => {
              this.bubuid = res.extraData.bubuId;
              console.log("this.bubuid", this.bubuid);
            },
          });
        }
      }
    },
    selectRole() {
      if (!this.loading && this.validation()) {
        this.loading = true;
        this.$api.whiteQuery({
          params: {
            "USER.LOGIN_ID": this.form.phone,
            URL: "/data/user/getUserListByAccount",
            APP_TOKEN: "9C4F2C2F67E34BB29BF296DBDBF26922",
            $DEBUG: "10301udbu13545",
            $LOG: true,
          },
          success: (res) => {
            const roleList = res.data.map((v) => {
              return {
                ...v,
                name: v["USER.NAME"],
              };
            });
            if (roleList.length && roleList.length > 1) {
              this.$refs.dialogSelect.show({
                list: roleList,
                title: "选择重置密码的角色",
                select: (res) => {
                  this.submit(
                    res["USER.LOGIN_ID"],
                    res["SERVICE_ID"],
                    res["SECRET_KEY"]
                  );
                },
              });
            } else {
              this.submit(
                roleList[0]["USER.LOGIN_ID"],
                roleList[0]["SERVICE_ID"],
                roleList[0]["SECRET_KEY"]
              );
            }
          },
          fail: (res) => {
            if (res && !res.data.length) {
              this.phoneWarn = res.msg;
            }
          },
          complete: () => {
            this.loading = false;
          },
        });
      }
    },
    submit(loginId, sId, secretKey) {
      this.$api.whiteQuery({
        headers: {
          token: this.bubuid,
        },
        params: {
          "USER.LOGIN_ID": loginId,
          APP_TOKEN: "9C4F2C2F67E34BB29BF296DBDBF26922",
          $DEBUG: "10301udbu13545",
          $LOG: true,
          URL: "/data/user/resetPassword",
          SECRET_KEY: secretKey,
          SERVICE_ID: sId,
          SMS_CODE: this.form.code,
          "USER.LOGIN_PASSWORD": this.form.password,
        },
        success: (res) => {
          if (res.msg === "ok") {
            alert("密码已重置，请重新登录");
            this.$router.push("/");
          }
        },
        fail: (res) => {
          if (res.msg.indexOf("验证码") !== -1) {
            this.codeWarn = res.msg;
          } else if (res.msg.indexOf("密码") !== -1) {
            this.passwordWarn = res.msg;
          } else {
            this.phoneWarn = res.msg;
          }
        },
      });
    },
    register() {
      this.$router.push({
        path: "/register",
      });
    },
    login() {
      this.$router.push({
        path: "/",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.error {
  margin-top: 3px;
  width: 13px;
  height: 13px;
}
.main-app-login {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f0f0f0;
  .container {
    max-width: 1014px;
    min-width: 828px;
    width: 80%;
    height: 610px;
    transform: translate(-50%, -50%);
    position: absolute;
    top: 50%;
    left: 50%;
    .img-area {
      width: 428px;
      height: 610px;
      display: inline-block;
      vertical-align: middle;
      position: relative;
      .text {
        position: absolute;
        top: 18%;
        left: -10%;
      }
      .img {
        width: 602px;
        height: 546px;
        display: block;
        transform: translate(-50%, -50%);
        position: absolute;
        top: 56%;
        left: 45%;
      }
    }
  }
  .input-item {
    padding-bottom: 30px;
    position: relative;
  }
  .input {
    width: 359px;
    height: 52px;
    border-radius: 4px;
    border: 1px solid #f0f1f3;
    padding: 0 15px;
    font-size: 18px;
    display: block;
    outline-color: #f46c50;
  }
  input::-webkit-input-placeholder {
    position: relative;
    font-size: 18px;
    color: #999999;
  }
  .input-item-tip {
    position: absolute;
    top: 57%;
    left: 0%;
    margin-top: 10px;
    font-size: 14px;
    color: #f46c50;
    line-height: 18px;
  }
  .input-item-tip:before {
    content: "";
  }
  .form-area {
    position: absolute;
    min-width: 480px;
    height: 557px;
    background-color: #ffffff;
    right: 0;
    left: 568px;
    bottom: 5%;
    box-shadow: 0px 8px 24px 0px rgba(240, 232, 232, 0.79);
    .form {
      width: 361px;
      max-width: 100%;
      padding-left: 5px;
      padding-right: 5px;
      transform: translate(-50%, -50%);
      position: absolute;
      top: 45%;
      left: 49.5%;
    }
    .title {
      font-size: 30px;
      color: #fff;
      margin-bottom: 20px;
    }
    .sec-title {
      margin-bottom: 30px;
    }
    .h2 {
      position: absolute;
      top: -9%;
      left: 1%;
      font-size: 30px;
      font-weight: bold;
      color: #333333;
      margin-right: 5px;
    }
    .login-register {
      position: absolute;
      bottom: 20px;
      left: 0;
      right: 0;
      font-size: 18px;
      padding: 32px 0 53px 0;
      text-align: center;
    }
    .copyright {
      position: absolute;
      bottom: -25px;
      left: 0;
      right: 0;
      text-align: center;
      color: #999999;
      font-size: 12px;
    }
  }
  .button-primary {
    background: linear-gradient(
      to right,
      rgba(255, 142, 80, 1) 0%,
      #ff5c50 100%
    );
    font-size: 24px;
    text-align: center;
    color: #fff;
    margin-top: 10px;
  }
  .button-primary:hover {
    opacity: 0.9;
  }
}
.button-min-inner {
  position: absolute;
  top: 15px;
  line-height: 24px;
  font-size: 16px;
  right: 12px;
}

.button-min {
  color: #f46c50;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
}
</style>
